'use client';
import classNames from 'classnames';
import { useState } from 'react';
import {
  AccordionTile,
  BaseAccordionTileProps,
} from './accordionTile/accordionTile';

export type AccordionProps = {
  tiles: BaseAccordionTileProps[];
  className?: string;
};

export function Accordion({ tiles, className }: AccordionProps) {
  const [activeTileIndex, setActiveTileIndex] = useState(-1);

  const handleTileClick = (index: number) => {
    setActiveTileIndex((previousTileIndex) =>
      previousTileIndex === index ? -1 : index
    );
  };

  return (
    <div className={classNames(['flex flex-col lg:gap-8', className])}>
      {tiles.map(({ ...tile }, index) => (
        <AccordionTile
          key={`accordionTile${index}`}
          isActive={index === activeTileIndex}
          onClick={() => handleTileClick(index)}
          {...tile}
        />
      ))}
    </div>
  );
}
